module.exports = __webpack_public_path__ + "static/media/Thermocycler.c3e43c09.svg";